import styled from "@emotion/styled";
import { Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  COLOR_BLACK,
  COLOR_GREY_2,
  COLOR_GREY_4,
  COLOR_GREY_9,
} from "shared/theme/colors";
import FlexCenter from "../Layout/components/FlexCenter";

export const StyledDataGrid = styled(DataGrid)`
  border: none;
  cursor: pointer;
  width: calc(100vw - 344px - 1.5rem);
  overflow: scroll;

  & .MuiDataGrid-columnHeaderTitle {
    color: ${COLOR_BLACK};
    font-weight: 700;
  }

  & .MuiDataGrid-iconButtonContainer {
    margin-left: 0.25rem;
  }

  .MuiDataGrid-virtualScroller {
    overflow: auto;
  }

  & .MuiDataGrid-columnHeader,
  .MuiDataGrid-cell {
    padding: 0.5rem;
    white-space: normal;
    outline: none;
    border-right: 1px solid ${COLOR_GREY_4};
    align-items: baseline;

    &:last-child {
      border-right: unset;
    }

    &:focus,
    &:focus-within {
      outline: none;
    }
  }

  & .MuiDataGrid-renderingZone {
    max-height: none !important;
  }

  & .MuiDataGrid-cell {
    line-height: unset !important;
    max-height: none !important;
    white-space: normal !important;
  }
  & .MuiDataGrid-row {
    max-height: auto !important;
  }
`;

export const StyledEmptyWrapper = styled(FlexCenter)`
  margin-top: 1rem;
  background-color: ${COLOR_GREY_2};
  height: 80px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 1rem;
`;

export const StyledPaper = styled(Paper)`
  box-shadow: none;
`;

export const StyledTypography = styled(Typography)`
  color: ${COLOR_GREY_9};
  font-size: 0.875rem;
  line-height: 1.875rem;
`;
